// extracted by mini-css-extract-plugin
export default {"root":"EnvironmentNotification_root__qvMkF","sub":"EnvironmentNotification_sub__S6DDu"};